import { render, staticRenderFns } from "./types-of-plans-and-their-uses.vue?vue&type=template&id=103fae26&scoped=true&"
import script from "./types-of-plans-and-their-uses.vue?vue&type=script&lang=js&"
export * from "./types-of-plans-and-their-uses.vue?vue&type=script&lang=js&"
import style0 from "./types-of-plans-and-their-uses.vue?vue&type=style&index=0&id=103fae26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103fae26",
  null
  
)

export default component.exports